module.exports = __webpack_public_path__ + "static/jim-lopez-about-623acbe76b079ba5114718b3d11f9d90.jpg";